import { render, staticRenderFns } from "./ListFiltersPanel.vue?vue&type=template&id=1218da4b&scoped=true&"
import script from "./ListFiltersPanel.vue?vue&type=script&lang=js&"
export * from "./ListFiltersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218da4b",
  null
  
)

export default component.exports